var _ = Object.defineProperty, x = Object.defineProperties;
var A = Object.getOwnPropertyDescriptors;
var n = Object.getOwnPropertySymbols;
var s = Object.prototype.hasOwnProperty, l = Object.prototype.propertyIsEnumerable;
var c = (o, r, t) => r in o ? _(o, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : o[r] = t, u = (o, r) => {
  for (var t in r || (r = {}))
    s.call(r, t) && c(o, t, r[t]);
  if (n)
    for (var t of n(r))
      l.call(r, t) && c(o, t, r[t]);
  return o;
}, I = (o, r) => x(o, A(r));
var O = (o, r) => {
  var t = {};
  for (var m in o)
    s.call(o, m) && r.indexOf(m) < 0 && (t[m] = o[m]);
  if (o != null && n)
    for (var m of n(o))
      r.indexOf(m) < 0 && l.call(o, m) && (t[m] = o[m]);
  return t;
};
import { jsx as p } from "react/jsx-runtime";
import E from "react";
import { iconButtonPropTypes as P } from "./common.es.js";
import * as S from "./style.es.js";
import { IconButton as b, Loading as g } from "./style.es.js";
import { COMPONENT_SIZE as d } from "../../../constants/sizes.es.js";
import { Icon as h } from "../../DataDisplay/Icon/Icon.es.js";
import { COLOR_VARIANT as j } from "../../../constants/colorVariant.es.js";
import { BUTTON_COLOR as w } from "../../../constants/color.es.js";
const e = E.forwardRef((M, L) => {
  var a = M, {
    children: o,
    loading: r = !1,
    disabled: t = !1,
    rounded: m = !0,
    size: f = d.md,
    variant: B = j.contained,
    color: T = w.primary,
    onClick: y,
    error: R = !1,
    iconName: i = "",
    type: C = "button"
  } = a, N = O(a, [
    "children",
    "loading",
    "disabled",
    "rounded",
    "size",
    "variant",
    "color",
    "onClick",
    "error",
    "iconName",
    "type"
  ]);
  return /* @__PURE__ */ p(b, I(u({ size: f, color: R ? "error" : T, disabled: t, rounded: m, onClick: y, variant: B, type: C }, N), { ref: L, children: r ? /* @__PURE__ */ p(g, { size: d.sm }) : i ? /* @__PURE__ */ p(h, { name: i, color: "currentColor", size: f }) : o }));
});
e.S = S;
e.displayName = "IconButton";
e.propTypes = P;
export {
  e as IconButton
};
//# sourceMappingURL=IconButton.es.js.map
